// Module CLIENT : il ne manipule aucun secret. La clé d'API OpenAI Ads vit
// uniquement dans la route serveur /api/oai (pas de préfixe NEXT_PUBLIC).

import { getStoredUtms } from "./utm";
import { sanitizedHref } from "./lead-prefill";

// ============================================================================
// OpenAI Ads — events serveur (Conversions API), en miroir du pixel navigateur.
//
//   Pourquoi doubler : le navigateur perd des événements (bloqueurs, onglet
//   fermé pendant la navigation, ITP). Surtout, le serveur peut joindre
//   l'identité hachée — c'est ce qui fait remonter la couverture email /
//   external ID, que la console OpenAI signalait à 0 %.
//
//   DÉDUPLICATION : l'`id` de l'event serveur DOIT être identique à l'`event_id`
//   passé à `oaiq("measure", …)` pour la même action, sinon elle est comptée
//   deux fois.
// ============================================================================

/** Identifiant visiteur stable, base de l'`external_id`. */
export const VISITOR_KEY = "hf_vid";

export function getVisitorId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    let v = window.localStorage.getItem(VISITOR_KEY);
    if (!v) {
      v =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.localStorage.setItem(VISITOR_KEY, v);
    }
    return v;
  } catch {
    // localStorage indisponible (navigation privée stricte) : on continue sans.
    return undefined;
  }
}

export type OpenAiUser = {
  email?: string;
  phone?: string;
};

/**
 * Envoie l'event au relais serveur. Fire-and-forget : la mesure ne doit jamais
 * ralentir ni casser le funnel.
 */
export function sendOpenAiServerEvent(
  type: string,
  dataType: string,
  eventId: string,
  user?: OpenAiUser
): void {
  if (typeof window === "undefined") return;
  try {
    fetch("/api/oai", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: eventId,
        type,
        data_type: dataType,
        source_url: sanitizedHref(),
        external_id: getVisitorId(),
        // `oppref` accompagne les clics publicitaires OpenAI ; il améliore
        // l'appariement quand il est présent.
        oppref: getStoredUtms().oppref,
        email: user?.email,
        phone: user?.phone,
      }),
      keepalive: true,
    }).catch(() => {
      /* échec silencieux */
    });
  } catch {
    /* idem */
  }
}
